import { useDispatch } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import useStaticListSizeQuota from "app/pages/sales-intelligence/hooks/useStaticListSizeQuota";
import useCurrentStaticList from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useCurrentStaticList";
import {
    toggleOpportunityListModal,
    toggleRecommendationsBarAction,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { openHooksModalV5 } from "app/services/ModalService";

import type { AddWebsitesDropdownProps } from "./AddWebsitesDropdown";
import AddWebsitesDropdown from "./AddWebsitesDropdown";

type Props = Partial<Pick<AddWebsitesDropdownProps, "isDisabled">>;

const AddWebsitesDropdownContainer = (props: Props) => {
    const { isDisabled = false } = props;
    const dispatch = useDispatch();
    const list = useCurrentStaticList();
    const { isListSizeQuotaReached } = useStaticListSizeQuota();

    const { translate } = useTranslate();

    function onWebsitesModalOpen() {
        dispatch(toggleOpportunityListModal(true, list));
    }

    function onRecommendationsOpen() {
        dispatch(toggleRecommendationsBarAction(true));
    }

    if (isListSizeQuotaReached) {
        return (
            <IconButton
                type="trialOutline"
                iconName="sparkles"
                onClick={() => openHooksModalV5("SalesSolutionLists")}
            >
                {translate("si.pages.my_lists.button.more_leads")}
            </IconButton>
        );
    }

    return (
        <AddWebsitesDropdown
            isDisabled={isDisabled}
            onOpenWebsitesModal={onWebsitesModalOpen}
            onOpenRecommendations={onRecommendationsOpen}
        />
    );
};

export default AddWebsitesDropdownContainer;
